<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div
    class="mt-4"
  >
    <promotion-list />
    <!--    <v-tabs-->
    <!--      v-model="tab"-->
    <!--      background-color="transparent"-->
    <!--      color="black"-->
    <!--      style="background: transparent"-->
    <!--    >-->
    <!--      <v-tab>促销规则</v-tab>-->
    <!--    </v-tabs>-->
    <!--    <v-divider />-->
    <!--    <v-tabs-items-->
    <!--      v-model="tab"-->
    <!--      class="mt-4"-->
    <!--      style="background: transparent"-->
    <!--    >-->
    <!--      <v-tab-item>-->
    <!--        <promotion-list />-->
    <!--      </v-tab-item>-->
    <!--    </v-tabs-items>-->
  </div>
</template>

<script>
import PromotionList from '@/views/AadenPages/extraModules/promotion/PromotionList.vue'

export default {
  name: 'PromotionIndex',
  components: {
    PromotionList
  },
  data () {
    return {
      tab: null
    }
  },
  async mounted () {
  }
}
</script>

<style scoped>

</style>
